/**
 * 住所選択モデル
 */
export class AddressSelectInfo {
	public address: string 			= null;
	public prefecture: string 				= null;
}
